import axios from "axios";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

var id;

export default {
  name: "students-single",
  components: {},
  props: [],
  data() {
    return {
      groups: ["A", "B", "C", "D"],
      show: true
    };
  },
  computed: {
    roles() {
      return this.$store.getters.getRoles;
    },
    teams() {
      return this.$store.getters.getTeams;
    },
    user() {
      let user = this.$store.getters.getUsers.find(
        u => u._id == this.$route.params.studentId
      );
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Backend" },
        { title: "Users", route: "students" },
        { title: "Students" },
        { title: user?.userName }
      ]);
      return user;
    }
  },

  methods: {
    onSubmit(evt) {
      id = this.$route.params.studentId;
      axios.put("users/" + id, this.user).then(response => {
        console.log(response.data);
        this.$store.dispatch("fetchUsers");
      });
      evt.preventDefault();
      this.$router.push({ name: "students" });
    }
  }
};
